import { initializeApp } from 'firebase/app'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getStorage, connectStorageEmulator } from 'firebase/storage'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)
const auth = getAuth()
const db = getFirestore(app)
const storage = getStorage(app)

if (process.env.NODE_ENV === 'development') {
  try {
    // Determine emulator host based on how site is accessed
    const host = window.location.hostname.match(/^192\.168\./)
      ? window.location.hostname // IP address access
      : 'localhost' // Local development

    console.log('Connecting to Firebase emulators at:', host)

    connectFirestoreEmulator(db, host, 8080)
    connectAuthEmulator(auth, `http://${host}:9099`)
    connectStorageEmulator(storage, host, 9199)

    console.log('Successfully connected to Firebase emulators')
  } catch (error) {
    console.error('Failed to connect to Firebase emulators:', error)
  }
}

export { db, storage, auth }
